const URL = process.env.NODE_ENV === 'production' ? 'https://tendyc-api.focusaqp.com/' : 'http://localhost:8000/';
export default URL; 